import { render, staticRenderFns } from "./ipadContent.vue?vue&type=template&id=9b0e91c0&scoped=true&"
import script from "./ipadContent.vue?vue&type=script&lang=js&"
export * from "./ipadContent.vue?vue&type=script&lang=js&"
import style0 from "./ipadContent.vue?vue&type=style&index=0&id=9b0e91c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0e91c0",
  null
  
)

export default component.exports